/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type AccountPage_viewer$ref = any;
export type AccountPage_QueryVariables = {};
export type AccountPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": AccountPage_viewer$ref;
    }) | null;
};
export type AccountPage_Query = {
    readonly response: AccountPage_QueryResponse;
    readonly variables: AccountPage_QueryVariables;
};



/*
query AccountPage_Query {
  viewer {
    id
    ...AccountPage_viewer
  }
}

fragment AccountPage_viewer on Viewer {
  id
  isLoggedIn
  ...MyAccountPage_viewer
  ...OrdersPage_viewer
  ...AddressesPage_viewer
  ...PaymentsPage_viewer
  ...Rewards_viewer
  ...SubscriptionSettings_viewer
}

fragment MyAccountPage_viewer on Viewer {
  id
  isLoggedIn
  ...FileUploadForm_viewer
  userInfo {
    profile {
      id
      image
      state
      personality
      summary
    }
    id
  }
  user {
    id
    ...ShopWithCeoDialog_user
    publicId
    userId
    password
    firstName
    lastName
    customUrl
    email
    mobilePhone
    role
    hasSSOAccount
    hasGoogleLogin
    hasFacebookLogin
    isResettingPassword
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
      }
    }
    preferredCustomerCeoAccountId
    shoppingWithCeoUser {
      firstName
      userId
      id
    }
    profile {
      id
      image
      city
      state
      zip
      summary
    }
    shippingAddressDefault {
      id
      lastName
      firstName
      street
      addressLineOne
      addressLineTwo
      city
      state
      addressId
      zip
    }
    paymentDefault {
      id
      name
      expMonth
      expYear
      last4
      paymentId
    }
  }
}

fragment OrdersPage_viewer on Viewer {
  user {
    id
    role
    ...OrderItem_user
    orders(first: 2, filterBy: "any", sortBy: "date") {
      edges {
        node {
          id
          orderId
          ...OrderItem_order
          __typename
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}

fragment AddressesPage_viewer on Viewer {
  id
  user {
    id
    role
    ...AccountAddressBook_user
    ...AccountAddAddressDialog_user
    shippingAddressDefault {
      addressId
      addressLineOne
      addressLineTwo
      city
      country
      firstName
      lastName
      nickname
      phoneNumber
      recipientBirthDate
      specialInstructions
      state
      street
      zip
      id
    }
  }
}

fragment PaymentsPage_viewer on Viewer {
  id
  user {
    id
    role
    ...AccountEditPaymentDialog_user
    ...AccountAddPaymentDialog_user
    paymentIdDefault
    paymentDefault {
      last4
      expYear
      expMonth
      billingAddressUuid
      paymentId
      brand
      nickname
      id
    }
    addressBook {
      entries(first: 100) {
        edges {
          node {
            id
            address {
              id
              addressId
              addressLineOne
              addressLineTwo
              city
              country
              firstName
              lastName
              nickname
              phoneNumber
              recipientBirthDate
              specialInstructions
              state
              street
              zip
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      id
    }
    stripePaymentCollection {
      id
      totalNumberOfStripePayment
      entries(first: 1000) {
        edges {
          node {
            stripePayment {
              ...StripePaymentV3_stripePayment
              ...AccountEditPaymentDialog_stripePayment
              id
              last4
              nickname
              expYear
              expMonth
              billingAddressUuid
              paymentId
              brand
            }
            id
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}

fragment Rewards_viewer on Viewer {
  id
  user {
    id
    pointBalance
  }
  v2 {
    id
    yotpo {
      id
      user {
        id
        historyItems {
          edges {
            node {
              id
              created_at
              action
              action_name
              points
              total_points
              status
            }
          }
        }
      }
    }
  }
}

fragment SubscriptionSettings_viewer on Viewer {
  ...MyGiveBack_viewer
  user {
    id
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
      }
    }
    subscriptions {
      ...MyMembership_subscriptions
      ...MySavings_subscriptions
      id
    }
    ...MyMembership_user
  }
}

fragment MyGiveBack_viewer on Viewer {
  user {
    id
    preferredCustomerNPO {
      isPreApproved
      nonProfitId
      nonProfitName
      nonProfitPayeeName
      nonProfitTaxId
      nonProfitAddress {
        phoneNumber
        addressLineTwo
        addressLineOne
        city
        state
        zip
      }
      id
    }
    cart {
      id
      preferredCustomerDraft {
        nonProfitId
        id
      }
    }
    subscriptions {
      preferredCustomer {
        npo
        donationProgress
        donationAmount
        id
      }
      id
    }
  }
  nonProfits(first: 1000, status: "preApproved", donationType: "preferredCustomer") {
    edges {
      node {
        id
        nonProfitId
        nonProfitName
        nonProfitDescription
      }
    }
  }
}

fragment MyMembership_subscriptions on Subscriptions {
  id
  preferredCustomer {
    grapefulCreationDate
    savings
    subscriptionId
    grapefulRenewalDate
    grapefulExpirationDate
    enrollmentStatus
    enrollmentCancelDate
    id
  }
  wineClub {
    marisCreationDate
    marisRenewalDate
    nextPaymentDate
    savings
    enrollmentStatus
    subscriptionStatus
    enrollmentCancelDate
    subscriptionCancelDate
    shippingAddress {
      ...AddressBookItem_address
      ...AddressBookItemTextMobile_address
      id
      addressId
      addressLineOne
      addressLineTwo
      city
      country
      firstName
      lastName
      companyName
      nickname
      phoneNumber
      recipientBirthDate
      specialInstructions
      state
      street
      zip
    }
    paymentInfo {
      ...StripePaymentV3_stripePayment
      id
      paymentId
      nickname
      brand
      last4
      expMonth
      expYear
    }
    subscriptionId
    id
  }
}

fragment MySavings_subscriptions on Subscriptions {
  preferredCustomer {
    savings
    id
  }
}

fragment MyMembership_user on User {
  ...ToggleMembership_user
  ...EditMembershipInfo_user
  id
  userId
  shippingAddressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            specialInstructions
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressDefault {
    ...AddressBookItem_address
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    nickname
    phoneNumber
    recipientBirthDate
    companyName
    specialInstructions
    state
    street
    zip
    id
  }
  paymentIdDefault
  paymentDefault {
    ...StripePaymentV3_stripePayment
    last4
    expYear
    expMonth
    billingAddressUuid
    paymentId
    brand
    nickname
    billingAddress {
      ...AddressBookItem_address
      addressLineOne
      addressLineTwo
      city
      country
      state
      zip
      id
    }
    id
  }
}

fragment ToggleMembership_user on User {
  id
  userId
  ...ConfirmMarisPickSubscription_user
  ...CancelMarisPicks_user
  ...AccountAddPaymentDialog_user
  ...AccountAddAddressDialogV2_user
  shippingAddressBook {
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            specialInstructions
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  subscriptions {
    wineClub {
      subscriptionId
      marisCreationDate
      marisRenewalDate
      nextPaymentDate
      savings
      enrollmentStatus
      subscriptionStatus
      id
    }
    id
  }
  shippingAddressDefault {
    ...AddressBookItem_address
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    specialInstructions
    state
    street
    zip
  }
  paymentIdDefault
  paymentDefault {
    ...StripePaymentV3_stripePayment
    id
    last4
    nickname
    expYear
    expMonth
    billingAddressUuid
    paymentId
    brand
    billingAddress {
      id
      addressLineOne
      addressLineTwo
      city
      country
      state
      zip
    }
  }
  stripePaymentCollection {
    ...SelectedStripePaymentV2_stripePaymentCollection
    totalNumberOfStripePayment
    entries(first: 1000) {
      edges {
        node {
          id
          stripePayment {
            ...AccountEditPaymentDialog_stripePayment
            ...StripePaymentV3_stripePayment
            id
            last4
            nickname
            expYear
            expMonth
            billingAddressUuid
            paymentId
            brand
            billingAddress {
              id
              addressLineOne
              addressLineTwo
              city
              country
              state
              zip
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment EditMembershipInfo_user on User {
  id
  userId
  ...SelectedAddress_user
  ...AccountAddPaymentDialog_user
  ...AccountAddAddressDialogV2_user
  ...EditSubscriptionAddressPaymentDialog_user
  subscriptions {
    id
    preferredCustomer {
      grapefulCreationDate
      savings
      subscriptionId
      grapefulRenewalDate
      grapefulExpirationDate
      enrollmentStatus
      enrollmentCancelDate
      id
    }
    wineClub {
      marisCreationDate
      marisRenewalDate
      nextPaymentDate
      savings
      enrollmentStatus
      subscriptionStatus
      enrollmentCancelDate
      subscriptionCancelDate
      shippingAddress {
        ...AddressBookItem_address
        ...AddressBookItemTextMobile_address
        id
        addressId
        addressLineOne
        addressLineTwo
        city
        country
        firstName
        lastName
        companyName
        nickname
        phoneNumber
        recipientBirthDate
        specialInstructions
        state
        street
        zip
      }
      paymentInfo {
        ...StripePaymentV3_stripePayment
        id
        paymentId
        nickname
        brand
        last4
        expMonth
        expYear
      }
      subscriptionId
      id
    }
  }
  shippingAddressBook {
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            specialInstructions
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  shippingAddressDefault {
    ...AddressBookItem_address
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    nickname
    phoneNumber
    recipientBirthDate
    companyName
    specialInstructions
    state
    street
    zip
    id
  }
  paymentIdDefault
  paymentDefault {
    ...StripePaymentV3_stripePayment
    id
    paymentId
    last4
    expYear
    expMonth
    billingAddressUuid
    brand
    nickname
    billingAddress {
      addressLineOne
      addressLineTwo
      city
      country
      state
      zip
      id
    }
  }
  stripePaymentCollection {
    ...SelectedStripePaymentV2_stripePaymentCollection
    totalNumberOfStripePayment
    entries(first: 1000) {
      edges {
        node {
          id
          stripePayment {
            ...AccountEditPaymentDialog_stripePayment
            ...StripePaymentV3_stripePayment
            id
            last4
            nickname
            expYear
            expMonth
            billingAddressUuid
            paymentId
            brand
            billingAddress {
              ...AddressBookItem_address
              id
              addressLineOne
              addressLineTwo
              city
              country
              state
              zip
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment AddressBookItem_address on Address {
  ...AddressBookItemText_address
  ...AddressBookItemTextMobile_address
  id
  addressId
  addressLineOne
  addressLineTwo
  city
  companyName
  country
  firstName
  lastName
  specialInstructions
  phoneNumber
  recipientBirthDate
  state
  zip
  nickname
}

fragment StripePaymentV3_stripePayment on StripePayment {
  ...AccountEditPaymentDialog_stripePayment
  id
  paymentId
  nickname
  brand
  last4
  expYear
  expMonth
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
  billingAddressUuid
}

fragment AccountEditPaymentDialog_stripePayment on StripePayment {
  ...EditPaymentDialogContent_stripePayment
  id
  last4
  nickname
  expYear
  expMonth
  billingAddressUuid
  paymentId
  brand
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
}

fragment EditPaymentDialogContent_stripePayment on StripePayment {
  ...EditPaymentInformation_stripePayment
  id
  last4
  nickname
  expYear
  expMonth
  billingAddressUuid
  paymentId
  brand
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
}

fragment EditPaymentInformation_stripePayment on StripePayment {
  id
  last4
  nickname
  expYear
  expMonth
  billingAddressUuid
  paymentId
  brand
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
}

fragment AddressBookItemText_address on Address {
  id
  addressId
  ...AddressBookItemStreet_address
  ...AddressBookItemName_address
}

fragment AddressBookItemTextMobile_address on Address {
  addressId
  addressLineOne
  addressLineTwo
  city
  companyName
  country
  firstName
  id
  lastName
  specialInstructions
  phoneNumber
  recipientBirthDate
  state
  zip
  nickname
}

fragment AddressBookItemStreet_address on Address {
  id
  addressId
  addressLineOne
  addressLineTwo
  city
  state
  zip
}

fragment AddressBookItemName_address on Address {
  nickname
  companyName
  firstName
  lastName
}

fragment SelectedAddress_user on User {
  id
  addressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            addressId
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  shippingAddressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            addressId
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment AccountAddPaymentDialog_user on User {
  shippingAddressIdDefault
  paymentIdDefault
  cart {
    id
    shippingAddress {
      addressId
      id
      lastName
      firstName
      street
      addressLineOne
      addressLineTwo
      city
      state
      zip
    }
  }
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            addressId
            lastName
            firstName
            street
            addressLineOne
            addressLineTwo
            city
            state
            zip
            phoneNumber
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
  }
  stripePaymentCollection {
    id
    totalNumberOfStripePayment
    totalNumberOfStripePayments
    entries(first: 1000) {
      edges {
        cursor
        node {
          id
          stripePayment {
            id
            name
            last4
            expYear
            expMonth
            billingAddressUuid
            paymentId
            object
            brand
            dynamicLast4
            funding
            tokenizationMethod
            billingAddress {
              id
              firstName
              lastName
              street
              addressLineOne
              addressLineTwo
              city
              state
              zip
              recipientBirthDate
              addressId
              country
              phoneNumber
              emailAddress
              specialInstructions
              nickname
              companyName
            }
            nickname
          }
          __typename
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment AccountAddAddressDialogV2_user on User {
  id
  shippingAddressDefault {
    id
    addressId
    lastName
    firstName
    street
    addressLineOne
    addressLineTwo
    city
    state
    zip
    phoneNumber
  }
  shippingAddressIdDefault
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            addressId
            lastName
            firstName
            street
            addressLineOne
            addressLineTwo
            city
            state
            zip
            phoneNumber
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
  }
}

fragment EditSubscriptionAddressPaymentDialog_user on User {
  id
  userId
  ...SelectedAddress_user
  stripePaymentCollection {
    ...SelectedStripePaymentV2_stripePaymentCollection
    id
  }
}

fragment SelectedStripePaymentV2_stripePaymentCollection on StripePaymentCollection {
  id
  ...StripePaymentCollectionV2_stripePaymentCollection
  entries(first: 1000) {
    edges {
      node {
        stripePayment {
          ...AccountEditPaymentDialog_stripePayment
          ...EditPaymentDialogContent_stripePayment
          ...StripePaymentV3_stripePayment
          id
          paymentId
          nickname
          brand
          last4
          expYear
          expMonth
          billingAddressUuid
          billingAddress {
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            state
            street
            zip
          }
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment StripePaymentCollectionV2_stripePaymentCollection on StripePaymentCollection {
  totalNumberOfStripePayment
  entries(first: 1000) {
    edges {
      node {
        id
        stripePayment {
          ...StripePaymentV2_stripePayment
          id
          paymentId
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment StripePaymentV2_stripePayment on StripePayment {
  ...AccountEditPaymentDialog_stripePayment
  id
  paymentId
  nickname
  brand
  last4
  expYear
  expMonth
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
  billingAddressUuid
}

fragment ConfirmMarisPickSubscription_user on User {
  id
  userId
  ...SelectedAddress_user
  stripePaymentCollection {
    ...SelectedStripePaymentV2_stripePaymentCollection
    id
  }
}

fragment CancelMarisPicks_user on User {
  id
  userId
}

fragment AccountEditPaymentDialog_user on User {
  ...EditPaymentDialogContent_user
  id
  shippingAddressIdDefault
  paymentIdDefault
  cart {
    id
    shippingAddress {
      addressId
      id
    }
    paymentInfo {
      paymentId
      id
    }
  }
  stripePaymentCollection {
    id
    entries(first: 1000) {
      edges {
        cursor
        node {
          id
          stripePayment {
            id
            name
            last4
            expYear
            expMonth
            billingAddressUuid
            paymentId
            brand
            nickname
            billingAddress {
              id
              firstName
              lastName
              street
              addressLineOne
              addressLineTwo
              city
              state
              zip
              recipientBirthDate
              addressId
              country
              phoneNumber
              emailAddress
              specialInstructions
              nickname
              companyName
            }
          }
          __typename
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment EditPaymentDialogContent_user on User {
  ...AccountAddressBook_user
  ...AccountAddAddressForm_user
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment AccountAddressBook_user on User {
  id
  addressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            ...AddressBookItem_address
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  shippingAddressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            ...AddressBookItem_address
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment AccountAddAddressForm_user on User {
  shippingAddressIdDefault
  addressBook {
    id
  }
}

fragment AccountAddAddressDialog_user on User {
  id
  shippingAddressDefault {
    id
    addressId
    lastName
    firstName
    street
    addressLineOne
    addressLineTwo
    city
    state
    zip
    phoneNumber
  }
  shippingAddressIdDefault
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            addressId
            lastName
            firstName
            street
            addressLineOne
            addressLineTwo
            city
            state
            zip
            phoneNumber
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
  }
}

fragment OrderItem_user on User {
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
      preferredCustomer {
        access
      }
    }
  }
  conciergeUser {
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    id
  }
}

fragment OrderItem_order on Order {
  id
  eventId
  event {
    id
    hostFullName
  }
  orderId
  orderNumber
  createDate
  orderStatus
  orderTotal
  orderTax
  orderSubTotal
  email
  isHostKitOrder
  isAutoShipOrder
  giftMessage {
    message
    recipientName
    from
  }
  giftReceipt
  isProcessing
  giftCards
  giftCardSavings
  promoCodes
  promoCodeSavings
  trinityTransmissionStatus
  trinityOrderId
  trinityPartyId
  orderItems {
    id
    quantity
    priceBought
    saleSavings
    product {
      id
      productId
      name
      price
      priceSale
      productURLslug
      staticUrl
      images {
        productCatalog
        squareFront
        id
      }
      content {
        impactSmall
        id
      }
      inventoryQuantity
      company
      inventorySKU
      inventoryClass
      inventoryText
      isSubscription
      promoCodeDiscount {
        case4Cause {
          case12PriceUSD
          case6PriceUSD
        }
      }
      productPermissions {
        oneCommerce {
          preferredCustomer {
            view
            add
          }
        }
      }
    }
  }
  shippingChosen
  shippingInfo {
    carrier
    tracking
    expectedDeliveryDate
    id
  }
  shippingAddress {
    firstName
    lastName
    specialInstructions
    street
    addressLineTwo
    city
    state
    zip
    phone
  }
  paymentInfo {
    name
    last4
    expYear
    expMonth
    billingAddressUuid
    provider
  }
  orderShipping
  billingAddressIsShippingAddress
  billingAddress {
    firstName
    lastName
    street
    addressLineTwo
    city
    state
    zip
  }
  recipientBirthDate
  pointsEarned
  pointsRedeemed
  rewardsCodeRedeemed
}

fragment FileUploadForm_viewer on Viewer {
  id
  user {
    id
    userId
    profile {
      id
      image
    }
  }
}

fragment ShopWithCeoDialog_user on User {
  role
  id
  cart {
    id
    eventId
  }
  ...ShopWithCeoProfile_user
  ceo {
    id
    userId
    firstName
    disableJoinMyTeam
    lastName
    trinityDealerId
    profile {
      image
      summary
      city
      state
      zip
      id
    }
  }
}

fragment ShopWithCeoProfile_user on User {
  ...EventsDropDown_user
  shoppingWithCeoUser {
    userId
    firstName
    id
  }
}

fragment EventsDropDown_user on User {
  ...DropDownAutoComplete_user
}

fragment DropDownAutoComplete_user on User {
  ...AuthDialog_user
  id
  userId
  publicId
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
    }
  }
  shoppingWithCeoUser {
    publicId
    id
  }
  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: "none", searchCEOS: false, searchEvents: false, searchProducts: false) {
    edges {
      cursor
      node {
        id
        isCEO
        image
        ceoId
        isEvent
        isProduct
        routePath
        primaryLabel
        secondaryLabel
        productCategory
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "image",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "summary",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressId",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "street",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineOne",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineTwo",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "paymentId",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "nonProfitId",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any), v18 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v19 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v18 /*: any*/)
    } as any), v20 = [
        ({
            "kind": "Literal",
            "name": "ceoId",
            "value": "none",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 25,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchCEOS",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchEvents",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchProducts",
            "value": false,
            "type": "Boolean"
        } as any)
    ], v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            (v23 /*: any*/),
            (v24 /*: any*/)
        ]
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "phoneNumber",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "country",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "nickname",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "recipientBirthDate",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "specialInstructions",
        "args": null,
        "storageKey": null
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "companyName",
        "args": null,
        "storageKey": null
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expMonth",
        "args": null,
        "storageKey": null
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expYear",
        "args": null,
        "storageKey": null
    } as any), v35 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "last4",
        "args": null,
        "storageKey": null
    } as any), v36 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "billingAddressUuid",
        "args": null,
        "storageKey": null
    } as any), v37 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "brand",
        "args": null,
        "storageKey": null
    } as any), v38 = [
        ({
            "kind": "Literal",
            "name": "filterBy",
            "value": "any",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 2,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "sortBy",
            "value": "date",
            "type": "String"
        } as any)
    ], v39 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfAddresses",
        "args": null,
        "storageKey": null
    } as any), v40 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
        } as any)
    ], v41 = [
        (v31 /*: any*/),
        (v0 /*: any*/),
        (v11 /*: any*/),
        (v12 /*: any*/),
        (v2 /*: any*/),
        (v3 /*: any*/),
        (v4 /*: any*/),
        (v28 /*: any*/),
        (v7 /*: any*/),
        (v9 /*: any*/),
        (v8 /*: any*/),
        (v27 /*: any*/),
        (v30 /*: any*/),
        (v26 /*: any*/),
        (v29 /*: any*/),
        (v10 /*: any*/)
    ], v42 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "entries",
        "storageKey": "entries(first:100)",
        "args": (v40 /*: any*/),
        "concreteType": "AddressBookEntryConnection",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "AddressBookEntryEdge",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AddressBookEntry",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "address",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Address",
                                "plural": false,
                                "selections": (v41 /*: any*/)
                            },
                            (v22 /*: any*/)
                        ]
                    },
                    (v21 /*: any*/)
                ]
            },
            (v25 /*: any*/)
        ]
    } as any), v43 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1000,
        "type": "Int"
    } as any), v44 = [
        (v43 /*: any*/)
    ], v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "nonProfitName",
        "args": null,
        "storageKey": null
    } as any), v46 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "savings",
        "args": null,
        "storageKey": null
    } as any), v47 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subscriptionId",
        "args": null,
        "storageKey": null
    } as any), v48 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrollmentStatus",
        "args": null,
        "storageKey": null
    } as any), v49 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrollmentCancelDate",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "AccountPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "AccountPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "AccountPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mobilePhone",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "profile",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Profile",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventHostFirstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shippingAddress",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Address",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v0 /*: any*/),
                                                (v8 /*: any*/),
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "paymentInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "StripePayment",
                                            "plural": false,
                                            "selections": [
                                                (v13 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "preferredCustomerDraft",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PreferredCustomerDraft",
                                            "plural": false,
                                            "selections": [
                                                (v14 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                (v15 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        (v0 /*: any*/),
                                        (v17 /*: any*/),
                                        (v9 /*: any*/)
                                    ]
                                },
                                (v17 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": (v18 /*: any*/)
                                                },
                                                (v19 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "storageKey": "autoCompleteData(ceoId:\"none\",first:25,searchCEOS:false,searchEvents:false,searchProducts:false)",
                                    "args": (v20 /*: any*/),
                                    "concreteType": "AutoCompleteEntryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "AutoCompleteEntryEdge",
                                            "plural": true,
                                            "selections": [
                                                (v21 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AutoCompleteDataEntry",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isProduct",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/),
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ceoId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isEvent",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isCEO",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "routePath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "primaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "secondaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCategory",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v25 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "args": (v20 /*: any*/),
                                    "handle": "connection",
                                    "key": "DropDownAutoComplete_DropDownAutoCompleteData",
                                    "filters": [
                                        "ceoId",
                                        "inputValue",
                                        "searchCEOS",
                                        "searchEvents",
                                        "searchProducts"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ceo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v16 /*: any*/),
                                        (v9 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "disableJoinMyTeam",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v8 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "trinityDealerId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v5 /*: any*/),
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "password",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "customUrl",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v16 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasGoogleLogin",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasFacebookLogin",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isResettingPassword",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "preferredCustomerCeoAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddressDefault",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v0 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v8 /*: any*/),
                                        (v4 /*: any*/),
                                        (v26 /*: any*/),
                                        (v27 /*: any*/),
                                        (v28 /*: any*/),
                                        (v29 /*: any*/),
                                        (v30 /*: any*/),
                                        (v31 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "paymentDefault",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StripePayment",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v32 /*: any*/),
                                        (v33 /*: any*/),
                                        (v34 /*: any*/),
                                        (v35 /*: any*/),
                                        (v13 /*: any*/),
                                        (v36 /*: any*/),
                                        (v37 /*: any*/),
                                        (v28 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "billingAddress",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Address",
                                            "plural": false,
                                            "selections": [
                                                (v31 /*: any*/),
                                                (v0 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v2 /*: any*/),
                                                (v27 /*: any*/),
                                                (v9 /*: any*/),
                                                (v8 /*: any*/),
                                                (v7 /*: any*/),
                                                (v28 /*: any*/),
                                                (v26 /*: any*/),
                                                (v29 /*: any*/),
                                                (v3 /*: any*/),
                                                (v10 /*: any*/),
                                                (v4 /*: any*/),
                                                (v30 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "permissions",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PermissionsType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "oneCommerce",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OneCommerceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v19 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orders",
                                    "storageKey": "orders(filterBy:\"any\",first:2,sortBy:\"date\")",
                                    "args": (v38 /*: any*/),
                                    "concreteType": "OrderConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OrderEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Order",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "promoCodes",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "event",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hostFullName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderNumber",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "createDate",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderStatus",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderTotal",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderTax",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderSubTotal",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v15 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isHostKitOrder",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isAutoShipOrder",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "giftMessage",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartGiftMessageType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "message",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "recipientName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "from",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "giftReceipt",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isProcessing",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "giftCards",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "giftCardSavings",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "promoCodeSavings",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "trinityTransmissionStatus",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "trinityOrderId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "trinityPartyId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "orderItems",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "OrderItem",
                                                            "plural": true,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "quantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceBought",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "saleSavings",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "content",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Content",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "impactSmall",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v0 /*: any*/)
                                                                            ]
                                                                        },
                                                                        (v0 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "price",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "priceSale",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "productURLslug",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "staticUrl",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "images",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Images",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "productCatalog",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "squareFront",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v0 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "productId",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "inventoryQuantity",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "company",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "inventorySKU",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "inventoryClass",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "inventoryText",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "isSubscription",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "promoCodeDiscount",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "PromoCodeDiscount",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "case4Cause",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Case4Cause",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "case12PriceUSD",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "case6PriceUSD",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "productPermissions",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ProductPermissions",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "oneCommerce",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AppProductPermissionsAccess",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "preferredCustomer",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ProductPermissionsAccess",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "alias": null,
                                                                                                    "name": "view",
                                                                                                    "args": null,
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "alias": null,
                                                                                                    "name": "add",
                                                                                                    "args": null,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "shippingChosen",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "shippingInfo",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ShippingInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "carrier",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "tracking",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "expectedDeliveryDate",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "shippingAddress",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "OrderAddress",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v3 /*: any*/),
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "phone",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "paymentInfo",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PaymentInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                (v32 /*: any*/),
                                                                (v35 /*: any*/),
                                                                (v34 /*: any*/),
                                                                (v33 /*: any*/),
                                                                (v36 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "provider",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderShipping",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "billingAddressIsShippingAddress",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "billingAddress",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "OrderAddress",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v3 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ]
                                                        },
                                                        (v29 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pointsEarned",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pointsRedeemed",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "rewardsCodeRedeemed",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ]
                                                },
                                                (v21 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                (v24 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasPreviousPage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": null,
                                    "name": "orders",
                                    "args": (v38 /*: any*/),
                                    "handle": "connection",
                                    "key": "Orders_orders",
                                    "filters": [
                                        "filterBy",
                                        "sortBy"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "addressBook",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AddressBook",
                                    "plural": false,
                                    "selections": [
                                        (v39 /*: any*/),
                                        (v42 /*: any*/),
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v40 /*: any*/),
                                            "handle": "connection",
                                            "key": "AddressBook_entries",
                                            "filters": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddressBook",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AddressBook",
                                    "plural": false,
                                    "selections": [
                                        (v39 /*: any*/),
                                        (v42 /*: any*/),
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v40 /*: any*/),
                                            "handle": "connection",
                                            "key": "ShippingAddressBook_entries",
                                            "filters": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shippingAddressIdDefault",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "paymentIdDefault",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "stripePaymentCollection",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StripePaymentCollection",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v44 /*: any*/),
                                            "concreteType": "StripePaymentCollectionEntryConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "StripePaymentCollectionEntryEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        (v21 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "StripePaymentCollectionEntry",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "stripePayment",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "StripePayment",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v37 /*: any*/),
                                                                        (v0 /*: any*/),
                                                                        (v35 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        (v33 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "billingAddress",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Address",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v0 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v2 /*: any*/),
                                                                                (v3 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v29 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v27 /*: any*/),
                                                                                (v26 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "emailAddress",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v30 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v31 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "object",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "dynamicLast4",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "funding",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "tokenizationMethod",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                (v22 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v25 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v44 /*: any*/),
                                            "handle": "connection",
                                            "key": "StripePaymentCollection_entries",
                                            "filters": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfStripePayment",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfStripePayments",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pointBalance",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "preferredCustomerNPO",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "NonProfit",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isPreApproved",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v14 /*: any*/),
                                        (v45 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "nonProfitPayeeName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "nonProfitTaxId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "nonProfitAddress",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "NonProfitAddress",
                                            "plural": false,
                                            "selections": [
                                                (v26 /*: any*/),
                                                (v12 /*: any*/),
                                                (v11 /*: any*/),
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/)
                                            ]
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "subscriptions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Subscriptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "preferredCustomer",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PreferredCustomerType",
                                            "plural": false,
                                            "selections": [
                                                (v46 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "npo",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "donationAmount",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "grapefulCreationDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "donationProgress",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v47 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "grapefulRenewalDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "grapefulExpirationDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v48 /*: any*/),
                                                (v49 /*: any*/)
                                            ]
                                        },
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "wineClub",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "WineClubType",
                                            "plural": false,
                                            "selections": [
                                                (v49 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "marisCreationDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "nextPaymentDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v46 /*: any*/),
                                                (v48 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "subscriptionStatus",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "marisRenewalDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "subscriptionCancelDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shippingAddress",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "plural": false,
                                                    "selections": (v41 /*: any*/)
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "paymentInfo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "StripePayment",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v35 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v37 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "billingAddress",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Address",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                (v0 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v27 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v3 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v47 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "profile",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Profile",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "personality",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v5 /*: any*/)
                                    ]
                                },
                                (v0 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "v2",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "V2",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "yotpo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Yotpo",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "YotpoUser",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "historyItems",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "YotpoHistoryItemConnection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "edges",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "YotpoHistoryItemEdge",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "node",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "YotpoUserHistoryItems",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "created_at",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "action",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "action_name",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "points",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "total_points",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "status",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "nonProfits",
                            "storageKey": "nonProfits(donationType:\"preferredCustomer\",first:1000,status:\"preApproved\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "donationType",
                                    "value": "preferredCustomer",
                                    "type": "String"
                                },
                                (v43 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "status",
                                    "value": "preApproved",
                                    "type": "String"
                                }
                            ],
                            "concreteType": "NonProfitConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "NonProfitEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "NonProfit",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v14 /*: any*/),
                                                (v45 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "nonProfitDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "AccountPage_Query",
            "id": null,
            "text": "query AccountPage_Query {\n  viewer {\n    id\n    ...AccountPage_viewer\n  }\n}\n\nfragment AccountPage_viewer on Viewer {\n  id\n  isLoggedIn\n  ...MyAccountPage_viewer\n  ...OrdersPage_viewer\n  ...AddressesPage_viewer\n  ...PaymentsPage_viewer\n  ...Rewards_viewer\n  ...SubscriptionSettings_viewer\n}\n\nfragment MyAccountPage_viewer on Viewer {\n  id\n  isLoggedIn\n  ...FileUploadForm_viewer\n  userInfo {\n    profile {\n      id\n      image\n      state\n      personality\n      summary\n    }\n    id\n  }\n  user {\n    id\n    ...ShopWithCeoDialog_user\n    publicId\n    userId\n    password\n    firstName\n    lastName\n    customUrl\n    email\n    mobilePhone\n    role\n    hasSSOAccount\n    hasGoogleLogin\n    hasFacebookLogin\n    isResettingPassword\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n      }\n    }\n    preferredCustomerCeoAccountId\n    shoppingWithCeoUser {\n      firstName\n      userId\n      id\n    }\n    profile {\n      id\n      image\n      city\n      state\n      zip\n      summary\n    }\n    shippingAddressDefault {\n      id\n      lastName\n      firstName\n      street\n      addressLineOne\n      addressLineTwo\n      city\n      state\n      addressId\n      zip\n    }\n    paymentDefault {\n      id\n      name\n      expMonth\n      expYear\n      last4\n      paymentId\n    }\n  }\n}\n\nfragment OrdersPage_viewer on Viewer {\n  user {\n    id\n    role\n    ...OrderItem_user\n    orders(first: 2, filterBy: \"any\", sortBy: \"date\") {\n      edges {\n        node {\n          id\n          orderId\n          ...OrderItem_order\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        endCursor\n      }\n    }\n  }\n}\n\nfragment AddressesPage_viewer on Viewer {\n  id\n  user {\n    id\n    role\n    ...AccountAddressBook_user\n    ...AccountAddAddressDialog_user\n    shippingAddressDefault {\n      addressId\n      addressLineOne\n      addressLineTwo\n      city\n      country\n      firstName\n      lastName\n      nickname\n      phoneNumber\n      recipientBirthDate\n      specialInstructions\n      state\n      street\n      zip\n      id\n    }\n  }\n}\n\nfragment PaymentsPage_viewer on Viewer {\n  id\n  user {\n    id\n    role\n    ...AccountEditPaymentDialog_user\n    ...AccountAddPaymentDialog_user\n    paymentIdDefault\n    paymentDefault {\n      last4\n      expYear\n      expMonth\n      billingAddressUuid\n      paymentId\n      brand\n      nickname\n      id\n    }\n    addressBook {\n      entries(first: 100) {\n        edges {\n          node {\n            id\n            address {\n              id\n              addressId\n              addressLineOne\n              addressLineTwo\n              city\n              country\n              firstName\n              lastName\n              nickname\n              phoneNumber\n              recipientBirthDate\n              specialInstructions\n              state\n              street\n              zip\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n    stripePaymentCollection {\n      id\n      totalNumberOfStripePayment\n      entries(first: 1000) {\n        edges {\n          node {\n            stripePayment {\n              ...StripePaymentV3_stripePayment\n              ...AccountEditPaymentDialog_stripePayment\n              id\n              last4\n              nickname\n              expYear\n              expMonth\n              billingAddressUuid\n              paymentId\n              brand\n            }\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment Rewards_viewer on Viewer {\n  id\n  user {\n    id\n    pointBalance\n  }\n  v2 {\n    id\n    yotpo {\n      id\n      user {\n        id\n        historyItems {\n          edges {\n            node {\n              id\n              created_at\n              action\n              action_name\n              points\n              total_points\n              status\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SubscriptionSettings_viewer on Viewer {\n  ...MyGiveBack_viewer\n  user {\n    id\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n      }\n    }\n    subscriptions {\n      ...MyMembership_subscriptions\n      ...MySavings_subscriptions\n      id\n    }\n    ...MyMembership_user\n  }\n}\n\nfragment MyGiveBack_viewer on Viewer {\n  user {\n    id\n    preferredCustomerNPO {\n      isPreApproved\n      nonProfitId\n      nonProfitName\n      nonProfitPayeeName\n      nonProfitTaxId\n      nonProfitAddress {\n        phoneNumber\n        addressLineTwo\n        addressLineOne\n        city\n        state\n        zip\n      }\n      id\n    }\n    cart {\n      id\n      preferredCustomerDraft {\n        nonProfitId\n        id\n      }\n    }\n    subscriptions {\n      preferredCustomer {\n        npo\n        donationProgress\n        donationAmount\n        id\n      }\n      id\n    }\n  }\n  nonProfits(first: 1000, status: \"preApproved\", donationType: \"preferredCustomer\") {\n    edges {\n      node {\n        id\n        nonProfitId\n        nonProfitName\n        nonProfitDescription\n      }\n    }\n  }\n}\n\nfragment MyMembership_subscriptions on Subscriptions {\n  id\n  preferredCustomer {\n    grapefulCreationDate\n    savings\n    subscriptionId\n    grapefulRenewalDate\n    grapefulExpirationDate\n    enrollmentStatus\n    enrollmentCancelDate\n    id\n  }\n  wineClub {\n    marisCreationDate\n    marisRenewalDate\n    nextPaymentDate\n    savings\n    enrollmentStatus\n    subscriptionStatus\n    enrollmentCancelDate\n    subscriptionCancelDate\n    shippingAddress {\n      ...AddressBookItem_address\n      ...AddressBookItemTextMobile_address\n      id\n      addressId\n      addressLineOne\n      addressLineTwo\n      city\n      country\n      firstName\n      lastName\n      companyName\n      nickname\n      phoneNumber\n      recipientBirthDate\n      specialInstructions\n      state\n      street\n      zip\n    }\n    paymentInfo {\n      ...StripePaymentV3_stripePayment\n      id\n      paymentId\n      nickname\n      brand\n      last4\n      expMonth\n      expYear\n    }\n    subscriptionId\n    id\n  }\n}\n\nfragment MySavings_subscriptions on Subscriptions {\n  preferredCustomer {\n    savings\n    id\n  }\n}\n\nfragment MyMembership_user on User {\n  ...ToggleMembership_user\n  ...EditMembershipInfo_user\n  id\n  userId\n  shippingAddressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            specialInstructions\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressDefault {\n    ...AddressBookItem_address\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    companyName\n    specialInstructions\n    state\n    street\n    zip\n    id\n  }\n  paymentIdDefault\n  paymentDefault {\n    ...StripePaymentV3_stripePayment\n    last4\n    expYear\n    expMonth\n    billingAddressUuid\n    paymentId\n    brand\n    nickname\n    billingAddress {\n      ...AddressBookItem_address\n      addressLineOne\n      addressLineTwo\n      city\n      country\n      state\n      zip\n      id\n    }\n    id\n  }\n}\n\nfragment ToggleMembership_user on User {\n  id\n  userId\n  ...ConfirmMarisPickSubscription_user\n  ...CancelMarisPicks_user\n  ...AccountAddPaymentDialog_user\n  ...AccountAddAddressDialogV2_user\n  shippingAddressBook {\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            specialInstructions\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  subscriptions {\n    wineClub {\n      subscriptionId\n      marisCreationDate\n      marisRenewalDate\n      nextPaymentDate\n      savings\n      enrollmentStatus\n      subscriptionStatus\n      id\n    }\n    id\n  }\n  shippingAddressDefault {\n    ...AddressBookItem_address\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    specialInstructions\n    state\n    street\n    zip\n  }\n  paymentIdDefault\n  paymentDefault {\n    ...StripePaymentV3_stripePayment\n    id\n    last4\n    nickname\n    expYear\n    expMonth\n    billingAddressUuid\n    paymentId\n    brand\n    billingAddress {\n      id\n      addressLineOne\n      addressLineTwo\n      city\n      country\n      state\n      zip\n    }\n  }\n  stripePaymentCollection {\n    ...SelectedStripePaymentV2_stripePaymentCollection\n    totalNumberOfStripePayment\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          stripePayment {\n            ...AccountEditPaymentDialog_stripePayment\n            ...StripePaymentV3_stripePayment\n            id\n            last4\n            nickname\n            expYear\n            expMonth\n            billingAddressUuid\n            paymentId\n            brand\n            billingAddress {\n              id\n              addressLineOne\n              addressLineTwo\n              city\n              country\n              state\n              zip\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment EditMembershipInfo_user on User {\n  id\n  userId\n  ...SelectedAddress_user\n  ...AccountAddPaymentDialog_user\n  ...AccountAddAddressDialogV2_user\n  ...EditSubscriptionAddressPaymentDialog_user\n  subscriptions {\n    id\n    preferredCustomer {\n      grapefulCreationDate\n      savings\n      subscriptionId\n      grapefulRenewalDate\n      grapefulExpirationDate\n      enrollmentStatus\n      enrollmentCancelDate\n      id\n    }\n    wineClub {\n      marisCreationDate\n      marisRenewalDate\n      nextPaymentDate\n      savings\n      enrollmentStatus\n      subscriptionStatus\n      enrollmentCancelDate\n      subscriptionCancelDate\n      shippingAddress {\n        ...AddressBookItem_address\n        ...AddressBookItemTextMobile_address\n        id\n        addressId\n        addressLineOne\n        addressLineTwo\n        city\n        country\n        firstName\n        lastName\n        companyName\n        nickname\n        phoneNumber\n        recipientBirthDate\n        specialInstructions\n        state\n        street\n        zip\n      }\n      paymentInfo {\n        ...StripePaymentV3_stripePayment\n        id\n        paymentId\n        nickname\n        brand\n        last4\n        expMonth\n        expYear\n      }\n      subscriptionId\n      id\n    }\n  }\n  shippingAddressBook {\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            specialInstructions\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  shippingAddressDefault {\n    ...AddressBookItem_address\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    companyName\n    specialInstructions\n    state\n    street\n    zip\n    id\n  }\n  paymentIdDefault\n  paymentDefault {\n    ...StripePaymentV3_stripePayment\n    id\n    paymentId\n    last4\n    expYear\n    expMonth\n    billingAddressUuid\n    brand\n    nickname\n    billingAddress {\n      addressLineOne\n      addressLineTwo\n      city\n      country\n      state\n      zip\n      id\n    }\n  }\n  stripePaymentCollection {\n    ...SelectedStripePaymentV2_stripePaymentCollection\n    totalNumberOfStripePayment\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          stripePayment {\n            ...AccountEditPaymentDialog_stripePayment\n            ...StripePaymentV3_stripePayment\n            id\n            last4\n            nickname\n            expYear\n            expMonth\n            billingAddressUuid\n            paymentId\n            brand\n            billingAddress {\n              ...AddressBookItem_address\n              id\n              addressLineOne\n              addressLineTwo\n              city\n              country\n              state\n              zip\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AddressBookItem_address on Address {\n  ...AddressBookItemText_address\n  ...AddressBookItemTextMobile_address\n  id\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  companyName\n  country\n  firstName\n  lastName\n  specialInstructions\n  phoneNumber\n  recipientBirthDate\n  state\n  zip\n  nickname\n}\n\nfragment StripePaymentV3_stripePayment on StripePayment {\n  ...AccountEditPaymentDialog_stripePayment\n  id\n  paymentId\n  nickname\n  brand\n  last4\n  expYear\n  expMonth\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n  billingAddressUuid\n}\n\nfragment AccountEditPaymentDialog_stripePayment on StripePayment {\n  ...EditPaymentDialogContent_stripePayment\n  id\n  last4\n  nickname\n  expYear\n  expMonth\n  billingAddressUuid\n  paymentId\n  brand\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n}\n\nfragment EditPaymentDialogContent_stripePayment on StripePayment {\n  ...EditPaymentInformation_stripePayment\n  id\n  last4\n  nickname\n  expYear\n  expMonth\n  billingAddressUuid\n  paymentId\n  brand\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n}\n\nfragment EditPaymentInformation_stripePayment on StripePayment {\n  id\n  last4\n  nickname\n  expYear\n  expMonth\n  billingAddressUuid\n  paymentId\n  brand\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n}\n\nfragment AddressBookItemText_address on Address {\n  id\n  addressId\n  ...AddressBookItemStreet_address\n  ...AddressBookItemName_address\n}\n\nfragment AddressBookItemTextMobile_address on Address {\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  companyName\n  country\n  firstName\n  id\n  lastName\n  specialInstructions\n  phoneNumber\n  recipientBirthDate\n  state\n  zip\n  nickname\n}\n\nfragment AddressBookItemStreet_address on Address {\n  id\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  zip\n}\n\nfragment AddressBookItemName_address on Address {\n  nickname\n  companyName\n  firstName\n  lastName\n}\n\nfragment SelectedAddress_user on User {\n  id\n  addressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            addressId\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  shippingAddressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            addressId\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AccountAddPaymentDialog_user on User {\n  shippingAddressIdDefault\n  paymentIdDefault\n  cart {\n    id\n    shippingAddress {\n      addressId\n      id\n      lastName\n      firstName\n      street\n      addressLineOne\n      addressLineTwo\n      city\n      state\n      zip\n    }\n  }\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            addressId\n            lastName\n            firstName\n            street\n            addressLineOne\n            addressLineTwo\n            city\n            state\n            zip\n            phoneNumber\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n  }\n  stripePaymentCollection {\n    id\n    totalNumberOfStripePayment\n    totalNumberOfStripePayments\n    entries(first: 1000) {\n      edges {\n        cursor\n        node {\n          id\n          stripePayment {\n            id\n            name\n            last4\n            expYear\n            expMonth\n            billingAddressUuid\n            paymentId\n            object\n            brand\n            dynamicLast4\n            funding\n            tokenizationMethod\n            billingAddress {\n              id\n              firstName\n              lastName\n              street\n              addressLineOne\n              addressLineTwo\n              city\n              state\n              zip\n              recipientBirthDate\n              addressId\n              country\n              phoneNumber\n              emailAddress\n              specialInstructions\n              nickname\n              companyName\n            }\n            nickname\n          }\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment AccountAddAddressDialogV2_user on User {\n  id\n  shippingAddressDefault {\n    id\n    addressId\n    lastName\n    firstName\n    street\n    addressLineOne\n    addressLineTwo\n    city\n    state\n    zip\n    phoneNumber\n  }\n  shippingAddressIdDefault\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            addressId\n            lastName\n            firstName\n            street\n            addressLineOne\n            addressLineTwo\n            city\n            state\n            zip\n            phoneNumber\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n  }\n}\n\nfragment EditSubscriptionAddressPaymentDialog_user on User {\n  id\n  userId\n  ...SelectedAddress_user\n  stripePaymentCollection {\n    ...SelectedStripePaymentV2_stripePaymentCollection\n    id\n  }\n}\n\nfragment SelectedStripePaymentV2_stripePaymentCollection on StripePaymentCollection {\n  id\n  ...StripePaymentCollectionV2_stripePaymentCollection\n  entries(first: 1000) {\n    edges {\n      node {\n        stripePayment {\n          ...AccountEditPaymentDialog_stripePayment\n          ...EditPaymentDialogContent_stripePayment\n          ...StripePaymentV3_stripePayment\n          id\n          paymentId\n          nickname\n          brand\n          last4\n          expYear\n          expMonth\n          billingAddressUuid\n          billingAddress {\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            state\n            street\n            zip\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment StripePaymentCollectionV2_stripePaymentCollection on StripePaymentCollection {\n  totalNumberOfStripePayment\n  entries(first: 1000) {\n    edges {\n      node {\n        id\n        stripePayment {\n          ...StripePaymentV2_stripePayment\n          id\n          paymentId\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment StripePaymentV2_stripePayment on StripePayment {\n  ...AccountEditPaymentDialog_stripePayment\n  id\n  paymentId\n  nickname\n  brand\n  last4\n  expYear\n  expMonth\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n  billingAddressUuid\n}\n\nfragment ConfirmMarisPickSubscription_user on User {\n  id\n  userId\n  ...SelectedAddress_user\n  stripePaymentCollection {\n    ...SelectedStripePaymentV2_stripePaymentCollection\n    id\n  }\n}\n\nfragment CancelMarisPicks_user on User {\n  id\n  userId\n}\n\nfragment AccountEditPaymentDialog_user on User {\n  ...EditPaymentDialogContent_user\n  id\n  shippingAddressIdDefault\n  paymentIdDefault\n  cart {\n    id\n    shippingAddress {\n      addressId\n      id\n    }\n    paymentInfo {\n      paymentId\n      id\n    }\n  }\n  stripePaymentCollection {\n    id\n    entries(first: 1000) {\n      edges {\n        cursor\n        node {\n          id\n          stripePayment {\n            id\n            name\n            last4\n            expYear\n            expMonth\n            billingAddressUuid\n            paymentId\n            brand\n            nickname\n            billingAddress {\n              id\n              firstName\n              lastName\n              street\n              addressLineOne\n              addressLineTwo\n              city\n              state\n              zip\n              recipientBirthDate\n              addressId\n              country\n              phoneNumber\n              emailAddress\n              specialInstructions\n              nickname\n              companyName\n            }\n          }\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment EditPaymentDialogContent_user on User {\n  ...AccountAddressBook_user\n  ...AccountAddAddressForm_user\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment AccountAddressBook_user on User {\n  id\n  addressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            ...AddressBookItem_address\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  shippingAddressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            ...AddressBookItem_address\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AccountAddAddressForm_user on User {\n  shippingAddressIdDefault\n  addressBook {\n    id\n  }\n}\n\nfragment AccountAddAddressDialog_user on User {\n  id\n  shippingAddressDefault {\n    id\n    addressId\n    lastName\n    firstName\n    street\n    addressLineOne\n    addressLineTwo\n    city\n    state\n    zip\n    phoneNumber\n  }\n  shippingAddressIdDefault\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            addressId\n            lastName\n            firstName\n            street\n            addressLineOne\n            addressLineTwo\n            city\n            state\n            zip\n            phoneNumber\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n  }\n}\n\nfragment OrderItem_user on User {\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n      preferredCustomer {\n        access\n      }\n    }\n  }\n  conciergeUser {\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment OrderItem_order on Order {\n  id\n  eventId\n  event {\n    id\n    hostFullName\n  }\n  orderId\n  orderNumber\n  createDate\n  orderStatus\n  orderTotal\n  orderTax\n  orderSubTotal\n  email\n  isHostKitOrder\n  isAutoShipOrder\n  giftMessage {\n    message\n    recipientName\n    from\n  }\n  giftReceipt\n  isProcessing\n  giftCards\n  giftCardSavings\n  promoCodes\n  promoCodeSavings\n  trinityTransmissionStatus\n  trinityOrderId\n  trinityPartyId\n  orderItems {\n    id\n    quantity\n    priceBought\n    saleSavings\n    product {\n      id\n      productId\n      name\n      price\n      priceSale\n      productURLslug\n      staticUrl\n      images {\n        productCatalog\n        squareFront\n        id\n      }\n      content {\n        impactSmall\n        id\n      }\n      inventoryQuantity\n      company\n      inventorySKU\n      inventoryClass\n      inventoryText\n      isSubscription\n      promoCodeDiscount {\n        case4Cause {\n          case12PriceUSD\n          case6PriceUSD\n        }\n      }\n      productPermissions {\n        oneCommerce {\n          preferredCustomer {\n            view\n            add\n          }\n        }\n      }\n    }\n  }\n  shippingChosen\n  shippingInfo {\n    carrier\n    tracking\n    expectedDeliveryDate\n    id\n  }\n  shippingAddress {\n    firstName\n    lastName\n    specialInstructions\n    street\n    addressLineTwo\n    city\n    state\n    zip\n    phone\n  }\n  paymentInfo {\n    name\n    last4\n    expYear\n    expMonth\n    billingAddressUuid\n    provider\n  }\n  orderShipping\n  billingAddressIsShippingAddress\n  billingAddress {\n    firstName\n    lastName\n    street\n    addressLineTwo\n    city\n    state\n    zip\n  }\n  recipientBirthDate\n  pointsEarned\n  pointsRedeemed\n  rewardsCodeRedeemed\n}\n\nfragment FileUploadForm_viewer on Viewer {\n  id\n  user {\n    id\n    userId\n    profile {\n      id\n      image\n    }\n  }\n}\n\nfragment ShopWithCeoDialog_user on User {\n  role\n  id\n  cart {\n    id\n    eventId\n  }\n  ...ShopWithCeoProfile_user\n  ceo {\n    id\n    userId\n    firstName\n    disableJoinMyTeam\n    lastName\n    trinityDealerId\n    profile {\n      image\n      summary\n      city\n      state\n      zip\n      id\n    }\n  }\n}\n\nfragment ShopWithCeoProfile_user on User {\n  ...EventsDropDown_user\n  shoppingWithCeoUser {\n    userId\n    firstName\n    id\n  }\n}\n\nfragment EventsDropDown_user on User {\n  ...DropDownAutoComplete_user\n}\n\nfragment DropDownAutoComplete_user on User {\n  ...AuthDialog_user\n  id\n  userId\n  publicId\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n    }\n  }\n  shoppingWithCeoUser {\n    publicId\n    id\n  }\n  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: \"none\", searchCEOS: false, searchEvents: false, searchProducts: false) {\n    edges {\n      cursor\n      node {\n        id\n        isCEO\n        image\n        ceoId\n        isEvent\n        isProduct\n        routePath\n        primaryLabel\n        secondaryLabel\n        productCategory\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '3a18d46c87289ebab972a85edbfd39a4';
export default node;
